const localURL = "https://localhost:7232";
const devURL = "https://speedtst-api-dev.musea2.azure.ext.gm.com";
const testURL = "https://speedtst-api-tst.musea2.azure.ext.gm.com";
const prodURL = "https://speedtst-api.musea2.azure.ext.gm.com";

const speedTestUrl = "https://gmit.speedtestcustom.com";

const preProdAuth = {
  auth_client_id: "2afc4d0f-7d93-4bba-ac2a-fbf7309d3a0a",
  auth_scope: "993b8169-3979-4c84-ac3c-21269e043f1e/.default",
  authority:
    "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d",
};

const prodAuth = {
  auth_client_id: "d32efa54-0885-4780-9280-0474d28e8997",
  auth_scope: "0b268b9e-5385-4c1c-9444-127ac88eaaa6/.default",
  authority:
    "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d",
};

const localEnv = {
  url: localURL,
  ...preProdAuth,
  speedTestUrl,
};
const devEnv = {
  url: devURL,
  ...preProdAuth,
  speedTestUrl,
};
const testEnv = {
  url: testURL,
  ...preProdAuth,
  speedTestUrl,
};
const prodEnv = {
  url: prodURL,
  ...prodAuth,
  speedTestUrl,
};

export const getEnv = () => {
  const url = window.location.origin;
  if (url.includes("-dev")) {
    return devEnv;
  }
  if (url.includes("-tst")) {
    return testEnv;
  }
  if (url.includes("3000")) {
    return localEnv;
  }
  return prodEnv;
};
